var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { SheetDirection } from 'frontend/js/modules/infra/dls/components/sheet/type';
import { getViewerIdAndKind, isShopSessionView } from 'frontend/js/modules/infra/session';
import { useBreakpoints } from 'frontend/js/modules/infra/dls/hooks/use-get-breakpoints';
import { Filters } from './filters';
import { endpoints } from '../../../network';
import { useApiQuery } from '../../../../../infra/api';
import { useSession } from '../../../../../infra/session/use-session';
export var EngageFiltersContainer = function (_a) {
    var open = _a.open, onClose = _a.onClose, filters = _a.filters, sort = _a.sort;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var direction = isMobileOrSmaller ? SheetDirection.Bottom : SheetDirection.Right;
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var _b = useState([]), creators = _b[0], setCreators = _b[1];
    var _c = useState(sort.sortName), localSort = _c[0], setLocalSort = _c[1];
    var _d = useState(filters.filterState.statusFilter), localStatus = _d[0], setLocalStatus = _d[1];
    var _e = useState(filters.filterState.typeFilter), localType = _e[0], setLocalType = _e[1];
    var _f = useState(filters.filterState.creatorFilter), localCreators = _f[0], setLocalCreators = _f[1];
    var creatorsByApiQuery = useApiQuery({
        endpoint: endpoints.campaignCreatorsFilterQuery,
        payload: { shopId: viewerIdAndKind.id },
        options: { enabled: isShopSessionView(session === null || session === void 0 ? void 0 : session.view) && !!viewerIdAndKind.id },
    }).data;
    useEffect(function () {
        var _a;
        if ((_a = creatorsByApiQuery === null || creatorsByApiQuery === void 0 ? void 0 : creatorsByApiQuery.ownerFilters) === null || _a === void 0 ? void 0 : _a.length) {
            var sorted = __spreadArray([], creatorsByApiQuery.ownerFilters, true).sort(function (a, b) { return a.firstName.localeCompare(b.firstName); });
            setCreators(sorted);
        }
    }, [creatorsByApiQuery]);
    useEffect(function () {
        if (open) {
            setLocalSort(sort.sortName);
            setLocalStatus(filters.filterState.statusFilter);
            setLocalType(filters.filterState.typeFilter);
            setLocalCreators(filters.filterState.creatorFilter);
        }
    }, [open, sort.sortName, filters]);
    var handleToggleCreator = function (id, checked) {
        setLocalCreators(function (current) { return (checked ? __spreadArray(__spreadArray([], current, true), [id], false) : current.filter(function (c) { return c !== id; })); });
    };
    var handleReset = function () {
        setLocalSort('createdAtDesc');
        setLocalStatus(undefined);
        setLocalType(undefined);
        setLocalCreators([]);
    };
    var handleShowResults = function () {
        sort.setSortName(localSort);
        filters.setStatusFilter(localStatus);
        filters.setTypeFilter(localType);
        filters.setCreatorFilter(localCreators);
        onClose();
    };
    // TODO: replace with endpoint when be ready
    var mockResultsCount = useMemo(function () { return 42; }, []);
    return (_jsx(Filters, { open: open, onClose: onClose, direction: direction, sortOrder: localSort, onSortChange: setLocalSort, status: localStatus, onStatusChange: setLocalStatus, type: localType, onTypeChange: setLocalType, creators: creators, creatorFilter: localCreators, onToggleCreator: handleToggleCreator, onReset: handleReset, onShowResults: handleShowResults, resultsCount: mockResultsCount, isMobileOrSmaller: isMobileOrSmaller }));
};
